module.exports = __webpack_public_path__ + "img/welcome.6dde2a48.jpg";